export default {
  nav: {
    home: "Главная",
    services: "Услуги",
    contacts: "Контакты",
  },
  actions: {
    call: "Позвонить",
    route: "Построить маршрут",
    allServices: "Все услуги",
  },
};
